// extracted by mini-css-extract-plugin
export default {"advertCardList":"c-a_gt","advertCardList_max6":"c-a_gu"};